import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, withDefaults } from '../../../adapter-vue';
export interface IOverlayProps {
  visible?: boolean;
  zIndex?: number | undefined;
  useMask?: boolean | undefined;
  maskColor?: string | undefined;
  isFullScreen?: boolean | undefined;
  width?: string;
  height?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    visible: { type: Boolean, default: true },
    zIndex: { default: 9999 },
    useMask: { type: [Boolean, null], default: true },
    maskColor: { default: 'rgba(0, 0, 0, 0.6)' },
    isFullScreen: { type: [Boolean, null], default: true },
    width: { default: 'auto' },
    height: { default: 'auto' }
  },
  emits: ['onOverlayClick'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { visible: boolean, zIndex: number | undefined, useMask: boolean | undefined, maskColor: string | undefined, isFullScreen: boolean | undefined, width: string, height: string }





const overlayDomRef = ref<HTMLElement>();
const isOverlayShow = ref<boolean>(props.visible);

watch(() => props.visible, (visible: boolean) => {
  if (visible) {
    isOverlayShow.value = true;
  } else {
    setTimeout(() => {
      isOverlayShow.value = false;
    }, 150);
  }
}, {
  immediate: true,
});

function onOverlayClick() {
  emits('onOverlayClick');
}

expose({
  overlayDomRef,
});

return { __sfc: true,emits, props, overlayDomRef, isOverlayShow, onOverlayClick }
}

})